import getMeetInfo from './GetMeetInfo';
import getRosterEntries from './GetRosterEntries';
import getRelayEntries from './GetRelayEntries';
import getCredentials from './GetCredentials';
import getEntryReports from './GetEntryReports';
import getSubmit from './GetSubmit';

const getLeftNavigationState = (viewName, route, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitEntryRosterPermissionsState) => {

  const items = [
    getMeetInfo(viewName, route, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitEntryRosterPermissionsState),
    getRosterEntries(viewName, route, omeMeetOrgUnitEntryInfoState),
    getRelayEntries(viewName, route),
    getCredentials(viewName, route, omeMeetOrgUnitEntryInfoState),
    getEntryReports(viewName, route),
    getSubmit(viewName, route, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitEntryRosterPermissionsState)
  ];

  return items;
};

export default getLeftNavigationState;